// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0d291c","white":"#fff","reviews":"styles_reviews__dcOEc","container":"styles_container__ZBqDf","wrapper":"styles_wrapper__03Ssq","media":"styles_media__Bl9lx"};